import GrassDisplacementEffect from './components/GrassDisplacementEffect';

function App() {
  return (
    <div className="App">
      <GrassDisplacementEffect />
    </div>
  );
}

export default App;